import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../common/utils/getApiReducer';

import { CREATE_GOLF_SCHOOL_CLASS, GET_GOLF_SCHOOLS, GET_GOLF_SCHOOL_CLASSES, EDIT_GOLF_SCHOOL_CLASS } from './actions';

const classesReducer = getApiReducer(GET_GOLF_SCHOOL_CLASSES);
const classes = (state, action) => {
  let newState = classesReducer(state, action);

  if (action.type === `${EDIT_GOLF_SCHOOL_CLASS}_SUCCESS`) {
    const classIndex = newState
      .getIn(['data', 'results'])
      .findIndex(item => item.get('id') === parseInt(action.classId, 10));

    const newClass = newState.getIn(['data', 'results', classIndex]).merge(fromJS(action.json));

    return newState.setIn(['data', 'results', classIndex], newClass);
  }

  if (action.type === `${CREATE_GOLF_SCHOOL_CLASS}_SUCCESS`) {
    return state.setIn(['data', 'results'], state.getIn(['data', 'results']).unshift(fromJS(action.json)));
  }

  return newState;
};

export default combineReducers({
  classes,
  schools: getApiReducer(GET_GOLF_SCHOOLS),
});



// WEBPACK FOOTER //
// ./src/golf-schools/reducers.js